import React from 'react'
import NoData from './NoData'

export default function Cards({
  cards
}) {
  return (
    <>
      <div className='col s12'>
        <div className='card'>
          <div className='card-content'>
            <div className='card-title'>
              Cards
            </div>

            <div className='card-body'>
              { cards && !!cards.length
                ? <table className="responsive-table">
                    <thead>
                      <tr>
                        <th>Issuer</th>
                        <th>Last 4</th>
                        <th>Expires at</th>
                        <th>Current</th>
                        <th>Archived at</th>
                      </tr>
                    </thead>
                    <tbody>
                      { cards.map((card, idx) => (
                        <tr key={ idx }>
                          <td>{ card.issuer }</td>
                          <td>****{ card.panLast4 }</td>
                          <td> { card.tokenExpirationDate }</td>
                          <td>
                            <i className={ card.current ? 'fa-light fa-check' : 'fa-light fa-xmark-large' } />
                          </td>
                          <td>
                            { card.deletedAt || '-' }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                : <NoData />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
